import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NProgress from 'nprogress'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    //{
    //  path: '/promotions',
    //  name: 'promotions',
    //  component: () => import('./views/Promotions.vue')
    //},
    {
      path: '/plans',
      name: 'plans',
      component: () => import('./views/Maintainance.vue')
    },
    {
      path: '/corporate',
      name: 'corporate',
      component: () => import('./views/Corporate.vue')
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import('./views/Partners.vue')
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: () => import('./views/Faqs.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: () => import('./views/Subscribe.vue')
    },
    {
      path: '/coming-soon',
      name: 'coming',
      component: () => import('./views/ComingSoon.vue')
    }
  ]
})


NProgress.configure({ easing: 'ease', speed: 500 })
router.beforeResolve((to, from, next) => {
  if (to.name) {
      NProgress.start()
  }
  next()
})
router.afterEach((to, from) => {
  NProgress.done()
})

export default router
